export const ed_tourism_annual_report = [
  {
    id: 1,
    name: 'Annual Performance Plan 2025-26',
    summary: 'shortsummary/Annual Performance Plan 2025-26.html',
    link: 'Annual Performance Plan 2025-26.pdf',
    audio_en: 'audio/en/Annual Performance Plan 2025-26_en.mp3',
    audio_af: 'audio/af/Annual Performance Plan 2025-26_af.mp3',
    audio_xh: 'audio/xh/Annual Performance Plan 2025-26_xh.mp3'
  },
  {
    id: 2,
    name: 'Strategic Plan-2025-30',
    summary: 'shortsummary/Strategic Plan-2025-30.html',
    link: 'Strategic Plan-2025-30.pdf',
    audio_en: 'audio/en/Strategic Plan-2025-30_en.mp3',
    audio_af: 'audio/af/Strategic Plan-2025-30_af.mp3',
    audio_xh: 'audio/xh/Strategic Plan-2025-30_xh.mp3'
  },
   {
    id: 3,
    name: 'wced-app-2025-2026',
    summary: 'shortsummary/wced-app-2025-2026.html',
    link: 'wced-app-2025-2026.pdf',
    audio_en: 'audio/en/wced-app-2025-2026_en.mp3',
    audio_af: 'audio/af/wced-app-2025-2026_af.mp3',
    audio_xh: 'audio/xh/wced-app-2025-2026_xh.mp3'
  }
];